<template >
  <b-container fluid >

    <b-row  align-v="center" class="card-form-purple pt-3 pb-3 mb-5 mt-4">
      <b-col cols="12" sm="4" class="col-form-avaluo">
            <b-form-select size="sm"  :options="catalogoPadrones.tiposRegimen" v-model="baseFiscal.regimenPropiedad"></b-form-select>
            <span :class="$v.baseFiscal.regimenPropiedad.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Regimen de Propiedad</span>
          
      </b-col>
      <b-col cols="12" sm="4"  class="col-form-avaluo"  >
        <b-form-select size="sm"   :options="catalogoPadrones.tiposPredio" v-model="baseFiscal.tipoPredio"></b-form-select>
        <span :class="$v.baseFiscal.tipoPredio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Tipo Inmueble</span>
      </b-col>
      <b-col cols="12" sm="4" class="col-form-avaluo" v-if="!baseFiscal.gestionCatastral">
        <b-form-select size="sm"  :options="catalogoPadrones.tiposUsoGral" v-model="baseFiscal.tipoUsoGral"></b-form-select>
        <span :class="$v.baseFiscal.tipoUsoGral.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Tipo Uso General</span>
      </b-col>
      <b-col cols="12" sm="4" class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
        <b-form-select size="sm"  :options="catalogoPadrones.tiposUso" v-model="baseFiscal.tipoUsoEspecifico"></b-form-select>
        <span :class="$v.baseFiscal.tipoUsoEspecifico.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Tipo Uso Específico</span>
      </b-col>
      
    </b-row>

    <b-row  align-v="stretch" class="card-form-purple pt-3 pb-3 pl-3 pr-3 mb-5 mt-4 ">
      <b-col cols="12" class="mt-3 ">
        <b-row align="center">
          <b-col>
            <h5><b-icon icon="map-fill"/> Terreno</h5>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4"  v-if="baseFiscal.gestionCatastral" align-self="stretch">
        <b-row align="center" v-if="baseFiscal.gestionCatastral">
          <b-col cols="12" class="mt-1" v-if="baseFiscal.regimenPropiedad.toLowerCase()!='privada condominio'"><h6><b-icon icon="grid-fill"/> Características del Predio</h6></b-col>
          <b-col cols="12" class="mt-1" v-if="baseFiscal.regimenPropiedad.toLowerCase()=='privada condominio'"><h6><b-icon icon="grid-fill"/> Características del Predio del Conjunto Urbano</h6></b-col>
        </b-row>
        <b-row align-v="stretch" v-if="baseFiscal.gestionCatastral" class="col-form-inner m-1 pt-3">
          <b-col>
            <b-row>
              <b-col >
                <b-row align-v="stretch" align-h="center" align="center">
                  
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                    <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.totalSupPredio"></b-form-input>
                    <span :class="$v.baseFiscal.totalSupPredio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup Total Predio</span>
                  </b-col>
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                      <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.totalAreaComun"></b-form-input>
                      <span :class="$v.baseFiscal.totalAreaComun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup Total Común</span>
                  </b-col>
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                    <b-form-input size="sm" class="input-form-cat" type="text" v-model="baseFiscal.areaAprovechamiento"></b-form-input>
                    <span :class="$v.baseFiscal.areaAprovechamiento.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">{{codeClient=='zacatlan' || codeClient=='huauchinango'?'Distancia Urbana (ml)' :'Área Aprovechable'}}</span>
                  </b-col>

                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                      <b-form-input size="sm" class="input-form-cat" type="text" v-model="baseFiscal.areaInscrita"></b-form-input>
                      <span :class="$v.baseFiscal.areaInscrita.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">{{codeClient=='zacatlan' || codeClient=='huauchinango'?'No. Esquinas':'Area Inscrita'}}</span>
                  </b-col>
                  
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col  v-if="baseFiscal.gestionCatastral">
                <b-row align-h="center" align="center">
                  
                  <b-col cols="12"  class="col-form-avaluo"  v-if="baseFiscal.gestionCatastral">
                    <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.frente"></b-form-input>
                    <span :class="$v.baseFiscal.frente.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Frente (m)</span>
                  </b-col>
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                    <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.fondo"></b-form-input>
                    <span :class="$v.baseFiscal.fondo.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Fondo (m)</span>
                  </b-col>
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                    <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.desnivel"></b-form-input>
                    <span :class="$v.baseFiscal.desnivel.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Desnivel (m)</span>
                  </b-col>
                  <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
                    <b-form-select size="sm"  :options="catalogoPadrones.ubicacionesMza" v-model="baseFiscal.ubicacionMza"></b-form-select>
                    <span :class="$v.baseFiscal.ubicacionMza.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Ubicación Manzanera</span>
                  </b-col>
                </b-row>
              </b-col>    
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4"  v-if="baseFiscal.gestionCatastral" align-self="stretch">
        <b-row align="center" v-if="baseFiscal.gestionCatastral">
          <b-col cols="12" class="mt-1"><h6><b-icon icon="grid-fill"/> Factores Mérito/Demérito</h6></b-col>
        </b-row>
        <b-row align-v="stretch" v-if="baseFiscal.gestionCatastral" class="col-form-inner m-1 pt-3">
          <b-col>
            <b-row align-h="center" align="center">
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorFrente"></b-form-input>
                <span :class="$v.baseFiscal.factorFrente.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Frente</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorFondo"></b-form-input>
                <span :class="$v.baseFiscal.factorFondo.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Fondo</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorIrregularidad"></b-form-input>
                <span :class="$v.baseFiscal.factorIrregularidad.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor {{codeClient=='zacatlan'||codeClient=='huauchinango'?'Distancia:':'Irregular:'}}</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorArea"></b-form-input>
                <span :class="$v.baseFiscal.factorArea.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Area</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row align-h="center" align="center">
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorTopografico"></b-form-input>
                <span :class="$v.baseFiscal.factorTopografico.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Topográfico</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorUbicacion"></b-form-input>
                <span :class="$v.baseFiscal.factorUbicacion.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Ubicación</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo" v-if="codeClient!='zacatlan'&&codeClient!='huauchinango'">
                <b-form-input :disabled="contribuyenteActual!=null && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.factorRestriccion"></b-form-input>
                <span :class="$v.baseFiscal.factorRestriccion.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Factor Restricción</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>    

      <b-col cols="4" align-self="stretch" v-if="baseFiscal.gestionCatastral">
        <b-row align="center" >
          <b-col cols="12" class="mt-1"><h6><b-icon icon="grid-fill"/> Valuación</h6></b-col>
        </b-row>
        <b-row  class="col-form-inner m-1 pt-3" >
          <b-col align-self="stretch">
            <b-row align-h="center" align="center" >
              <b-col cols="12" class="col-form-avaluo" v-if="catalogoPadrones.zonas!= null && catalogoPadrones.zonas.length>0">
                <b-form-select size="sm" :options="catalogoPadrones.zonas" v-model="baseFiscal.zonaVal"></b-form-select>
                <span :class="'label-form-avaluo'">Zona Valuación</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo">            
                  <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieTerrenoPropio"></b-form-input>
                  <span :class="$v.baseFiscal.superficieTerrenoPropio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup. Terreno Propio</span>
              </b-col>
              <b-col cols="12" class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoPropio"></b-form-input>
                <span :class="$v.baseFiscal.valorTerrenoPropio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Propio</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col align-self="stretch">
            <b-row align-h="center" align="center" >
              <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO' && baseFiscal.gestionCatastral" >
                <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.pjeCondominio"></b-form-input>
                <span :class="$v.baseFiscal.pjeCondominio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">% Proindiviso</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'" >
                <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieTerrenoComun"></b-form-input>
                <span :class="$v.baseFiscal.superficieTerrenoComun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup Terreno Común</span>
              </b-col>
              <b-col cols="12"  class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'">
                  <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoCommun"></b-form-input>
                  <span :class="$v.baseFiscal.valorTerrenoCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Común</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" align-self="stretch" v-if="!baseFiscal.gestionCatastral">
        
        <b-row  align-h="center" >
          
             <b-col cols="12" sm="6" lg="3" class="col-form-avaluo">      
                  <b-form-input size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieTerrenoPropio"></b-form-input>
                  <span :class="$v.baseFiscal.superficieTerrenoPropio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup. Terreno Propio</span>
              </b-col>
              <b-col cols="12" sm="6" lg="3" class="col-form-avaluo">
                <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoPropio"></b-form-input>
                <span :class="$v.baseFiscal.valorTerrenoPropio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Propio</span>
              </b-col>
            
          
              
              <b-col cols="12" sm="6" lg="3"  class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'" >
                <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieTerrenoComun"></b-form-input>
                <span :class="$v.baseFiscal.superficieTerrenoComun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Sup Terreno Común</span>
              </b-col>
              <b-col cols="12" sm="6" lg="3"  class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'">
                  <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoCommun"></b-form-input>
                  <span :class="$v.baseFiscal.valorTerrenoCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Común</span>
              </b-col>
           
        </b-row>
      </b-col>

     </b-row>
    
    
    
   

   


    <!------- VALUACION CONSTRUCCIONES ------------------------------>
    <b-row  align-v="center" align-h="center" align="center" class="card-form-purple pt-3 pb-3 mb-5"  >      
      <b-col cols="12" class="mt-3 ">
        <b-row align="center">
          <b-col>
            <h5><b-icon icon="house-fill"/> Construcción</h5>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" sm="6" lg="3" class="col-form-avaluo">
        <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieConstruccionPropia"></b-form-input>
        <span :class="$v.baseFiscal.superficieConstruccionPropia.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Superficie Contrucción Propia m2</span>
      </b-col>   
      <b-col cols="12" sm="6" lg="3" class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'" >
        <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.superficieConstruccionCommun"></b-form-input>
        <span :class="$v.baseFiscal.superficieConstruccionCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Superficie Construcción Común m2</span>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class="col-form-avaluo">
        <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorConstruccionPropia"></b-form-input>
        <span :class="$v.baseFiscal.valorConstruccionPropia.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Construcción Propia</span>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class="col-form-avaluo" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'">
        <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorConstruccionCommun"></b-form-input>
        <span :class="$v.baseFiscal.valorConstruccionCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Construcción Común</span>
      </b-col>          

      <!--------- Lista de Construcciones ---------------->
      <b-col cols="12" class="mb-2" v-if="this.baseFiscal.gestionCatastral && contribuyenteActual !=null ">
        <b-row>
          <!----------- Lista de Construcciones ------------------------>
          <b-col cols="12" class="mt-2"><h6><b-icon icon="house-fill"/> Construcciones del Inmueble</h6></b-col>
          <b-col class="mb-2">
            <b-tabs content-class="mt-3" fill>
              <b-tab title="Propias" active>
                  <b-row style=" font-size:14px;" class="mb-2">
                    <b-col cols="2"><b>Año</b></b-col>
                    <b-col cols="2"><b>Tipologia</b></b-col>
                    <b-col cols="2"><b>Area</b></b-col>
                    <b-col cols="2"><b>Conservación</b></b-col>
                    <b-col cols="1"><b>Niv</b></b-col>
                    <b-col cols="2"><b>Valor</b></b-col>
                    <b-col cols="1"><b>Acciones</b></b-col>
                  </b-row>
                  <b-row v-for="(item, idx) in contribuyenteActual.construcciones" :key="idx">
                    <b-col>
                      <b-row v-if="item.regimen!='PRIVADA CONDOMINIO'" >
                        <b-col cols="2"><b-form-input size="sm" v-model="item.año"/></b-col>
                        <b-col cols="2"><b-form-select :options="catalogoPadrones.tipologias" size="sm" v-model="item.tipologia"/></b-col>
                        <b-col cols="2"><b-form-input size="sm" v-model="item.area"/></b-col>
                        <b-col cols="2"><b-form-select :options="catalogoPadrones.estadosConservacion" size="sm" v-model="item.conservacion"/></b-col>
                        <b-col cols="1"><b-form-input size="sm" v-model="item.niveles"/></b-col>
                        <b-col cols="2"><b-form-input size="sm" v-model="item.valorConst"/></b-col>
                        <b-col cols="1"><b-icon style="cursor:pointer;" icon="cloud-check-fill" @click="editarConstruccion(item)"/> <b-icon style="cursor:pointer;"  icon="trash-fill" @click="borrarConstruccion(item)"/></b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <!-- AGREGAR NUEVA CONSTRUCCION  --->
                  <b-row align="right">
                    <b-col class="mt-5 mb-4"><b-form-checkbox v-model="isShowAgregarNuevaConst">Agregar Nueva Construcción <b-icon icon="house-fill"/></b-form-checkbox></b-col>
                  </b-row>
                  <b-row v-if="isShowAgregarNuevaConst" class="mb-3">
                    <b-col cols="2"><b>Año</b></b-col>
                    <b-col cols="2"><b>Tipologia</b></b-col>
                    <b-col cols="2"><b>Area</b></b-col>
                    <b-col cols="2"><b>Conservación</b></b-col>
                    <b-col cols="1"><b>Niv</b></b-col>
                  </b-row>
                  <b-row v-if="isShowAgregarNuevaConst">
                    <b-col cols="2"><b-form-input size="sm" v-model="nuevaConstruccion.año"/></b-col>
                      <b-col cols="2"><b-form-select :options="catalogoPadrones.tipologias" size="sm" v-model="nuevaConstruccion.tipologia"/></b-col>
                      <b-col cols="2"><b-form-input size="sm" v-model="nuevaConstruccion.area"/></b-col>
                      <b-col cols="2"><b-form-select :options="catalogoPadrones.estadosConservacion" size="sm" v-model="nuevaConstruccion.conservacion"/></b-col>
                      <b-col cols="1"><b-form-input size="sm" v-model="nuevaConstruccion.niveles"/></b-col>
                      <b-col cols="3">
                        <b-dropdown size="sm" split variant="danger" @click="agregarConstruccion">
                          <template #button-content>
                            <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                            <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
                            <strong v-if="!isGuardandoDatosContrib"> Guardar<b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
                          </template>                              

                          <b-dropdown-form>
                            <b-form-group >
                                <b-form-textarea
                                  v-model="nuevaConstruccion.fundamento"
                                  placeholder="Fundamento ..."
                                  rows="3"
                                  max-rows="3"
                                ></b-form-textarea>
                            </b-form-group>
                          </b-dropdown-form>
                        </b-dropdown>
                      </b-col>
                  </b-row>
                  <b-row v-if="isShowAgregarNuevaConst && catalogoPadrones.vinculaCartografia" class="mt-3">
                    
                    <b-col v-if="nuevasConstruccionesCarto!=null" cols="12">
                      <b-row  v-for="ncons in this.nuevasConstruccionesCarto" :key="ncons.id">
                        <b-col cols="2"><b-form-input disabled size="sm" v-model="ncons.año"/></b-col>
                          <b-col cols="2"><b-form-select disabled :options="catalogoPadrones.tipologias" size="sm" v-model="ncons.tipologia"/></b-col>
                          <b-col cols="2"><b-form-input disabled size="sm" v-model="ncons.area"/></b-col>
                          <b-col cols="2"><b-form-select disabled :options="catalogoPadrones.estadosConservacion" size="sm" v-model="nuevaConstruccion.conservacion"/></b-col>
                          <b-col cols="1"><b-form-input disabled size="sm" v-model="ncons.niveles"/></b-col>
                          <b-col cols="3">
                            <b-button size="sm" @click="setConstFromCarto(ncons)"  variant="info">Usar Cartografia <b-icon icon="cursor-fill" /></b-button>
                          </b-col>
                      </b-row>
                    </b-col>
                  
                  </b-row>
              </b-tab>
              <b-tab title="Comunes">
                  <b-row>
                    <b-col cols="2"><b>Año</b></b-col>
                    <b-col cols="2"><b>Tipologia</b></b-col>
                    <b-col cols="2"><b>Area</b></b-col>
                    <b-col cols="3"><b>Conservación</b></b-col>
                    <b-col cols="1"><b>Niv</b></b-col>
                    <b-col cols="2"><b>Valor Actual</b></b-col>
                  </b-row>
                  <div v-for="(item, idx) in contribuyenteActual.construcciones" :key="idx">
                    <b-row v-if="item.regimen=='PRIVADA CONDOMINIO'" >
                      <b-col cols="2"><b-form-input size="sm" v-model="item.año"/></b-col>
                      <b-col cols="2"><b-form-select :options="catalogoPadrones.tipologias" size="sm" v-model="item.tipologia"/></b-col>
                      <b-col cols="2"><b-form-input size="sm" v-model="item.area"/></b-col>
                      <b-col cols="3"><b-form-select :options="catalogoPadrones.estadosConservacion" size="sm" v-model="item.conservacion"/></b-col>
                      <b-col cols="1"><b-form-input size="sm" v-model="item.niveles"/></b-col>
                      <b-col cols="2"><b-form-input size="sm" v-model="item.valorConst"/></b-col>
                    </b-row>
                  </div>
                  <!-- <b-row align-h="center">
                    <b-col cols="10" sm="6" md="4" class="mt-4"><b-button size="sm" variant="success">Agrgar Construcción <b-icon icon="house-fill"/></b-button></b-col>
                    <b-col cols="10" sm="6" md="4" class="mt-4"><b-button size="sm" variant="danger">Guardar Cambios <b-icon icon="cloud-check-fill"/></b-button></b-col>
                  </b-row> -->
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-col>      
      <!-- <b-col cols="12" class="mb-5">
        <b-row align-h="center" >
          <b-col cols="2" sm="2" lg="2" @dblclick="obtenerConstruccionesCarto">
            <b-img src="@/assets/tecnicosc.png" fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>
      </b-col> -->
      
      
    </b-row>

     <b-row  align-v="center" align-h="center" align="center" class="card-form-purple pt-3 pb-3 mb-5 mt-4">
      
      <!-- <b-col cols="8" md="4" lg="4">
        <b-row><b-col><b-img src="@/assets/valuacion.png" fluid-grow alt="Fluid-grow image"></b-img></b-col></b-row>
      </b-col> -->
      <b-col cols="12"  >
        <b-row align-h="center">
          <b-col cols="12" class="mt-1"><h6><b-icon icon="table"/> Valor Catastral</h6></b-col>
          <b-col cols="12" class="mt-1 mb-3" sm="6" lg="2 ">
            <b-form-input class="input-form-cat" :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm"  type="text" v-model="baseFiscal.año"></b-form-input><!--contribuyenteActual.basesFiscales[idxOfArrayBases]-->
            <span class="label-form-avaluo">Año fiscal</span>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <!-- <b-col cols="12" sm="6" lg="2" class="col-form-avaluo">
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral" size="sm" :state="!$v.baseFiscal.año.$invalid" type="number" v-model="baseFiscal.año"></b-form-input>
            <span class="label-form-avaluo">Año</span>
          </b-col> -->
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoPropio"></b-form-input>
            <span :class="$v.baseFiscal.valorTerrenoPropio.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Propio</span>
          </b-col>
          <b-col cols="12" sm="6" lg="2"  class="col-form-avaluo" v-if="baseFiscal.gestionCatastral && baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'">
              <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorTerrenoCommun"></b-form-input>
              <span :class="$v.baseFiscal.valorTerrenoCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Terreno Común</span>
          </b-col>
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" v-if="baseFiscal.gestionCatastral">
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorConstruccionPropia"></b-form-input>
            <span :class="$v.baseFiscal.valorConstruccionPropia.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Construcción Propia</span>
          </b-col>
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" v-if="baseFiscal.gestionCatastral && baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'">
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorConstruccionCommun"></b-form-input>
            <span :class="$v.baseFiscal.valorConstruccionCommun.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Construcción Comun</span>
          </b-col>    
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" >
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="text" v-model="baseFiscal.valorCatastral"></b-form-input>
            <span :class="$v.baseFiscal.valorCatastral.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Valor Catastral</span>
          </b-col>      
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" v-if="codeClient!='tula' && codeClient!='chimalhuacan'">
            <b-form-input :disabled="contribuyenteActual!=null&&baseFiscal.gestionCatastral && !camposEditables" size="sm" class="input-form-cat" type="number" v-model="baseFiscal.importe"></b-form-input><!--contribuyenteActual.basesFiscales[idxOfArrayBases]-->
            <span :class="$v.baseFiscal.importe.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Impuesto</span>
          </b-col>
          <b-col cols="12" sm="6" lg="2" class="col-form-avaluo" v-if="codeClient=='tula'">
            <b-form-select  v-model="baseFiscal.clasificacion" :options="catalogoPadrones.clasificaciones"></b-form-select><!--contribuyenteActual.basesFiscales[idxOfArrayBases]-->
            <span :class="$v.baseFiscal.clasificacion.$invalid? 'label-form-avaluo-err':'label-form-avaluo'">Tarifa Cobro</span>
          </b-col>
        </b-row>
        
      </b-col>      
    </b-row>
    
    <!-- <b-row align="center" align-h="center" align-v="center" class="card-form-purple pt-3 pb-3 mb-5" >
      <b-col cols="12" class="mt-3" v-if="baseFiscal.regimenPropiedad!='PRIVADA CONDOMINIO'"><h5><b-icon icon="geo-fill"/> Ubicación del Inmueble</h5></b-col>
          <b-col cols="12" class="mt-3" v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'"><h5><b-icon icon="geo-fill" /> Ubicación del Fraccionamiento</h5></b-col>
      <b-col cols="8" md="4" lg="4">
        <b-row><b-col><b-img src="@/assets/ubicacion.png" fluid-grow alt="Fluid-grow image"></b-img></b-col></b-row>
      </b-col>
      <b-col cols="12" md="8" >
        <b-row>
          <b-col cols="12" sm="6" lg="4">
            <b-form-group>
              <b-icon style="cursor:pointer;" icon="plus-square" @click="isShowModalCalles=true"/> <label>Vialidad:</label>
              <model-select size="sm" :state="!$v.baseFiscal.calle.$invalid" :options="this.calles" v-model="baseFiscal.calle"></model-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="4">
            <b-form-group >
              <b-icon style="cursor:pointer;" icon="plus-square" @click="isShowModalColonia=true"/> <label>Colonia:</label>
              <model-select size="sm"  :state="!$v.baseFiscal.colonia.$invalid" :options="colonias" v-model="baseFiscal.colonia"></model-select>          
            </b-form-group>        
          </b-col>
          <b-col cols="12" sm="6" lg="4">
            <b-form-group>
              <b-icon style="cursor:pointer;" icon="plus-square" @click="isShowModalLocalidad=true"/> <label>Localidad:</label>
              <model-select size="sm" :state="!$v.baseFiscal.localidad.$invalid" :options="localidades" v-model="baseFiscal.localidad"></model-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="2">
            <b-form-group label="No. Ext.">
              <b-form-input size="sm" :state="!$v.baseFiscal.numExt.$invalid" type="text" v-model="baseFiscal.numExt"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="2" v-if="baseFiscal.regimenPropiedad!='PRIVADA CONDOMINIO'">
            <b-form-group label="No. Int.">
              <b-form-input size="sm" :state="!$v.baseFiscal.numInt.$invalid" type="text" v-model="baseFiscal.numInt"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="6" v-if="baseFiscal.regimenPropiedad!='PRIVADA CONDOMINIO'" >
            <b-form-group label="Manzana - Lote (Fraccionamiento):">
              <b-form-input size="sm" :state="!$v.baseFiscal.extraInfo.$invalid" type="text" v-model="baseFiscal.extraInfo"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="4">
            <b-form-group label="Código Postal">
              <b-form-input size="sm" :state="!$v.baseFiscal.codPostal.$invalid" type="text" v-model="baseFiscal.codPostal"></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col cols="12" sm="6" >
            <b-form-group label="Entre calle">
              <b-form-input size="sm" :state="!$v.baseFiscal.entCalle.$invalid" type="text" v-model="baseFiscal.entCalle"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" >
            <b-form-group label="y calle">
              <b-form-input size="sm" :state="!$v.baseFiscal.yCalle.$invalid" type="text" v-model="baseFiscal.yCalle"></b-form-input>
            </b-form-group>
          </b-col>
          
        </b-row>
        <b-row v-if="baseFiscal.regimenPropiedad=='PRIVADA CONDOMINIO'" align="left">
          <b-col cols="12"><h6>Ubicación del Inmueble dentro del fraccionamiento</h6></b-col>
          <b-col cols="12" sm="6" lg="2">
            <b-form-group label="No. Int.">
              <b-form-input size="sm" :state="!$v.baseFiscal.numInt.$invalid" type="text" v-model="baseFiscal.numInt"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="6">
            <b-form-group label="Manzana - Lote:">
              <b-form-input size="sm" :state="!$v.baseFiscal.extraInfo.$invalid" type="text" v-model="baseFiscal.extraInfo"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row> -->
    

   

    

    <b-row align-h="between" align="between" class="mt-4 mb-4" >
      <b-col cols="11" sm="6"  class="mt-2">
        <!-- <b-button block variant="danger" @click="validateForm">
          <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
          <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
          <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
        </b-button> -->

        <b-dropdown split variant="danger" @click="validateForm">
          <template #button-content>
            <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
            <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
            <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios  <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
          </template>
          

          <b-dropdown-form v-if="contribuyenteActual!=null">
            <b-form-group >
                <b-form-textarea
                  v-model="contribuyenteActual.fundamento"
                  placeholder="Fundamento ..."
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
                <b-form-checkbox v-model="aplicarAñosAtras">Aplicar para años anteriores</b-form-checkbox>
                <b-form-checkbox v-model="aplicarAñosAdelante">Aplicar para años posteriores</b-form-checkbox>
            </b-form-group>
          </b-dropdown-form>

        </b-dropdown>

      </b-col>

      <b-col cols="11" sm="6"  class="mt-2" v-if="baseFiscal.gestionCatastral">

        <b-dropdown split variant="info" >
          <template #button-content>
            <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
            <strong v-if="isGuardandoDatosContrib"> Generando . . .</strong>
            <strong v-if="!isGuardandoDatosContrib"> Generar Documento <b-icon  shift-v="-1" font-scale="1.3" icon="file-earmark-text-fill"/></strong>
          </template>
          

          <b-dropdown-form v-if="contribuyenteActual!=null">
            <b-form-group >
                <b-form-input
                  v-model="folioDoc1"
                  placeholder="Folio Documento"
                ></b-form-input>
                <b-form-input
                  v-model="folioDoc2"
                  placeholder="Folio Pago"
                ></b-form-input>
            </b-form-group>
          </b-dropdown-form>
          <b-dropdown-item @click="generarDocumento(1, 'Certificado de Clave')"><b-icon icon="arrow-right-circle-fill"/> Certificado de Clave</b-dropdown-item>
          <b-dropdown-item @click="generarDocumento(1, 'Certificado de Clave y Valor Catastral')"><b-icon icon="arrow-right-circle-fill"/> Certificado de Clave y Valor Catastral</b-dropdown-item>
          <b-dropdown-item @click="generarDocumento(1, 'Manifestación Catastral')"><b-icon icon="arrow-right-circle-fill"/> Avalúo / Manifestacion Catastral</b-dropdown-item>
          <b-dropdown-item @click="isShowDocInspeccion=true"><b-icon icon="arrow-right-circle-fill"/> Documento de Inspección</b-dropdown-item>
          
          
        </b-dropdown>
        <b-form-checkbox v-model="imprimirDocBaseF">Solo imprmir</b-form-checkbox>
      </b-col>

      
      <!-- {{$v}} -->
    </b-row>
    

    <b-modal v-model="isShowDocInspeccion" title="Generación Documento de Inspección" header-bg-variant="dark" header-text-variant="light" hide-footer>
      <b-row>
        <b-col cols="12" class="mt-3 mb-3">
          <h5><b-icon icon="list"/> Ingrese la evidencia de inspección</h5>
        </b-col>
        <b-col v-if="filesInspeccion.length<4"  cols="12">
          <b-form-file id="img1" @change="saveFileToB64" size="sm" accept="image/jpeg, image/png, image/jpg" placeholder="Eliga o Arrastre un archivo aquí ..." drop-placeholder="Arrastre el archivo aquí..."  />
        </b-col>
      </b-row>
      <b-row align="end">
        <b-col cols="12"><b-button v-if="filesInspeccion.length>0" @click="filesInspeccion=[]" variant="link">Borrar archivos<b-icon font-scale=".9" shift-v="2" icon="trash"/></b-button></b-col>
      </b-row>
      <b-row>
      <b-col v-if="filesInspeccion[0]!=null" cols="6"><b-img fluid :src="filesInspeccion[0]"/></b-col>
        <b-col v-if="filesInspeccion[1]!=null" cols="6"><b-img fluid :src="filesInspeccion[1]"/></b-col>
        <b-col v-if="filesInspeccion[2]!=null" cols="6"><b-img fluid :src="filesInspeccion[2]"/></b-col>
        <b-col v-if="filesInspeccion[3]!=null" cols="6"><b-img fluid :src="filesInspeccion[3]"/></b-col>
      </b-row>
      <b-row align-h="right">
        <b-col cols="12" class="mt-4 mb-3"><b-button @click="generarDocumento(1, 'Inspección Técnica')" variant="success" size="sm">Generar Documento <b-icon icon="arrow-right-circle"/></b-button></b-col>
        <b-col cols="12" v-if="isGuardandoDatosContrib">
            <b-overlay :show="isGuardandoDatosContrib" rounded="lg">
              <div style="height:70px;"></div>
            </b-overlay>
        </b-col>
      </b-row>
    </b-modal>


  <!-------- CARTOGRAFIA ------>
    <b-modal v-model="showTerrCarto" title="Superficie Cartográfica" header-bg-variant="dark" header-text-variant="light" hide-footer>
      <b-row>
        <b-col cols="12" v-if="supTerrPropCarto==null"><h5>Sin dato</h5></b-col>
        <b-col cols="12" v-if="supTerrPropCarto!=null"><h5>Superficie m2: {{supTerrPropCarto}} <b-badge @click="setTerrenoFromCarto()" style="cursor:pointer" variant="info">Usar</b-badge></h5></b-col>
        <b-col><b-button @click="obtenerTerrenoCarto">Obtener superficie <b-icon icon="map-fill"/> <b-spinner small v-if="consultandoCarto" /> </b-button></b-col>
      </b-row> 
    </b-modal>
    


  </b-container>
</template>

<script>
  import axios from 'axios';
  import { numeric, between, helpers , decimal, required, requiredIf} from 'vuelidate/lib/validators';
  import { mapState } from 'vuex';
  import { server, checkAuth, getPostConfig, handledError } from '@/axios-tools';
  //import { ModelSelect } from 'vue-search-select'
  import Printjs from "print-js";

  const numericPlus = helpers.regex('alphaplus', /^[.&0-9 ]*$/)

  export default {
    props:['baseFiscal', 'guardarCambiosContrib', 'isGuardandoDatosContrib', 'contribuyenteActual',],
    computed: {
    ...mapState({
      catalogoPadrones: state=> state.padrones.catalogoPadrones,
      token: state => state.login.token
      
    }),
    // calles : function(){
    //   var cs = [];
    //   for(var idx=0; idx < this.catalogoPadrones.calles.length; idx++){
    //     if(this.catalogoPadrones.calles[idx].codZona == this.baseFiscal.codZona){
    //       cs.push({value:this.catalogoPadrones.calles[idx].descripcion, text:this.catalogoPadrones.calles[idx].descripcion});
    //     }
    //   }
    //   return cs;
    // },
    // colonias : function(){
    //   var cs = [];
    //   for(var idx=0; idx < this.catalogoPadrones.colonias.length; idx++){
    //       cs.push({value:this.catalogoPadrones.colonias[idx], text:this.catalogoPadrones.colonias[idx]});
    //   }
    //   return cs;
    // },
    // localidades : function(){
    //   var cs = [];
    //   for(var idx=0; idx < this.catalogoPadrones.localidades.length; idx++){
    //       cs.push({value:this.catalogoPadrones.localidades[idx], text:this.catalogoPadrones.localidades[idx]});
    //   }
    //   return cs;
    // },
    },
    components: {
      //ModelSelect
    },
    data() {
      return {
        codeClient:this.$route.params.municipio,
        camposEditables: this.$route.params.municipio=='zacatlan' || this.$route.params.municipio=='huauchinango',

        folioDoc1:"",
        folioDoc2:"",
        aplicarAñosAtras:false,
        aplicarAñosAdelante:false,
        isShowAgregarNuevaConst:false,
        
        isShowDocInspeccion: false,
        filesInspeccion:[],

        nuevaConstruccion:{
          año:null,
          tipologia:null,
          area:null,
          conservacion:null,
          niveles:null,
          clavePredio:null,
          numero:"0",
          regimen:"SIN DESCRIPCION",
          id:-1,
          valorConst:"0",
          fundamento:"",
          poligono:""
        },

        //Cartografia
        consultandoCarto : false,
        showTerrCarto: false,
        supTerrPropCarto : null,
        nuevasConstruccionesCarto : null,

        //
        imprimirDocBaseF:true

      }
    },
    methods: {
      validateForm(){
        if(!this.$v.$invalid){
          var up = this.aplicarAñosAdelante ? "1" : "0";
          var down = this.aplicarAñosAtras ? "1" : "0";
          this.guardarCambiosContrib(this.aplicarAñosAtras||this.aplicarAñosAdelante?this.baseFiscal.año:null, up, down);
            this.folioDoc1="";
            this.folioDoc2="";
            this.aplicarAñosAtras=false;
        }
      },
      generarDocumento: function(tipoPadron, documento){
        if(!this.isGuardandoDatosContrib & checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          var body={
            idContrib: this.contribuyenteActual.idContrib,
            tipoPadron : tipoPadron,
            doc : documento,
            folio : this.folioDoc1,
            folioPago : this.folioDoc2,
            anexos : this.filesInspeccion,
            añoFiscal : this.baseFiscal.año
          }
          
          axios(
            getPostConfig(server.generadoccontrib, body, this.token, {})            
            ).then(res => {
              if(!this.imprimirDocBaseF){
                var pdf= 'data:application/pdf;base64,'+res.data[0];              
                var downloadPdf = document.createElement('a');
                downloadPdf.setAttribute('href', pdf);
                downloadPdf.setAttribute('download', documento+"_"+body.folio+".pdf");
                downloadPdf.click(); 
              
                if(res.data[1] !=null){
                  let pdfAnexo= 'data:application/octet-stream;base64,'+res.data[1];              
                  let downloadPdfAnexo = document.createElement('a');
                  downloadPdfAnexo.setAttribute('href', pdfAnexo);
                  downloadPdfAnexo.setAttribute('download', documento+"_"+body.folio+".xls");
                  downloadPdfAnexo.click();  
                }

                if(res.data[2] !=null){
                  let pdfAnexo= 'data:application/pdf;base64,'+res.data[2];              
                  let downloadPdfAnexo = document.createElement('a');
                  downloadPdfAnexo.setAttribute('href', pdfAnexo);
                  downloadPdfAnexo.setAttribute('download', documento+"_"+body.folio+"_Anexo.pdf");
                  downloadPdfAnexo.click();  
                }
                
              }else{
                this.printPDFBase64(res.data[0]);
                
              }
              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.generadoccontrib, this.$router, this.$store);
            })
        }
      },
      printPDFBase64(base64) {
        
        Printjs({
            printable: base64,
            type: "pdf",
            base64: true
        });
      },
      saveFileToB64(evt){
        //this.$store.commit("updateIsWorking", true);
        var f = evt.target.files[0];
        var reader = new FileReader();
        //Creamos una refrencia local al objeto this para poder acceder desde las funciones anidadas a los objetos cliente, token .. etc
        var thisObject = this;
        reader.onload = function (e) {
            var img = document.createElement("img");
            img.onload = function () {
                var MAX_WIDTH = 465;
                var MAX_HEIGHT = 465;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                // Dynamically create a canvas element
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                // var canvas = document.getElementById("canvas");
                var ctx = canvas.getContext("2d");

                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);

                // Show resized image in preview element
                var dataurl = canvas.toDataURL(f.type);
                if(thisObject.filesInspeccion.length<4){
                  thisObject.filesInspeccion.push( dataurl);
                }
            }
            img.src = e.target.result;
        }
        reader.onerror = function(error){
          alert("error al cargar archivo"+error);
        };
        reader.readAsDataURL(f);
      },
      agregarConstruccion(){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          this.nuevaConstruccion.clavePredio = this.contribuyenteActual.clave;
          axios(
            getPostConfig(server.agregaconstruccion, this.nuevaConstruccion, this.token, {})            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;

              this.nuevaConstruccion.año = "";
              this.nuevaConstruccion.tipologia = "";
              this.nuevaConstruccion.area = "";
              this.nuevaConstruccion.niveles = "";
              this.nuevaConstruccion.conservacion = "";
              
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.agregaconstruccion, this.$router, this.$store);
            })
        }
      },
      editarConstruccion(construccion){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editaconstruccion, construccion, this.token, {})            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editaconstruccion, this.$router, this.$store);
            })
        }
      },
      borrarConstruccion(construccion){
        
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.borraconstruccion, construccion, this.token, {})            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.borraconstruccion, this.$router, this.$store);
            })
        }
      },
      obtenerTerrenoCarto(){
        this.consultandoCarto = true;
        axios(
            getPostConfig(server.terrenocarto, this.contribuyenteActual, this.token, {})            
            ).then(res => {
              this.supTerrPropCarto = res.data.superficieTerrenoPropio;
              this.consultandoCarto = false;
            }).catch(err => {
              this.consultandoCarto = false;
              alert(err.data);

            })
      },
      obtenerConstruccionesCarto(){
        this.consultandoCarto = true;
        axios(
            getPostConfig(server.construccionescarto, this.contribuyenteActual, this.token, {})            
            ).then(res => {
              this.nuevasConstruccionesCarto= res.data;
              this.consultandoCarto = false;
            }).catch(err => {
              this.consultandoCarto = false;
              alert(err.data);

            })
      },
      setTerrenoFromCarto(){
        
        this.baseFiscal.superficieTerrenoPropio = this.supTerrPropCarto;
        this.baseFiscal.totalSupPredio = this.supTerrPropCarto;
        this.baseFiscal.areaInscrita = this.supTerrPropCarto;
        this.baseFiscal.areaAprovechamiento = this.supTerrPropCarto;
        this.showTerrCarto = false;
      },
      setConstFromCarto(ncons){
        this.nuevaConstruccion.año = ncons.año;
        this.nuevaConstruccion.tipologia = ncons.tipologia;
        this.nuevaConstruccion.area = ncons.area;
        this.nuevaConstruccion.niveles = ncons.niveles;
        this.nuevaConstruccion.conservacion = ncons.conservacion;
        
      }
      
    },
    validations: {
      baseFiscal:{
        año:{
          required,
          numeric
        },
        valorCatastral:{
          required:requiredIf(function(){return !this.baseFiscal.gestionCatastral}),
          // numericPlus,
          // between: between(0, 99999999)
        },
        importe:{
          numericPlus,
          between: between(0, 99999999)
        },
        superficieConstruccionCommun:{
          required:requiredIf(function(){ this.baseFiscal.regimenPropiedad.toLowerCase().includes('condominio')}),
          numericPlus,
          between: between(0, 99999999)
        },
        superficieConstruccionPropia:{
          required,
          numericPlus,
          between: between(0, 99999999)
        },
        superficieTerrenoComun:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral && this.baseFiscal.regimenPropiedad !=null && this.baseFiscal.regimenPropiedad.toLowerCase().includes('condominio')}),
          numericPlus,
          between: between(0, 99999999)
        },
        superficieTerrenoPropio:{
          required,
          numericPlus,
          between: between(0, 99999999)
        },
        areaAprovechamiento:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral}),
          numericPlus,
          between: between(0, 99999999)
        },
        areaInscrita:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral}),
          numericPlus,
          between: between(0, 99999999)
        },
        valorConstruccionCommun:{
          // required,
          // numericPlus,
          // between: between(0, 99999999)
        },
        valorConstruccionPropia:{
          // required,
          // numericPlus,
          // between: between(0, 99999999)
        },
        valorTerrenoCommun:{
          // required,
          // numericPlus,
          // between: between(0, 99999999)
        },
        valorTerrenoPropio:{
          // required,
          // numericPlus,
          // between: between(0, 99999999)
        },
        tipoPredio:{
          required
        },
        tipoUsoGral:{
          required:requiredIf(function(){return (this.catalogoPadrones.edomex && !this.baseFiscal.gestionCatastral) || (!this.catalogoPadrones.edomex)}),
        },
        tipoUsoEspecifico:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral}),
        },
        ubicacionMza:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral}),
        },
        factorFrente:{
          numericPlus,
        },
        factorFondo:{
          numericPlus,
        },
        factorIrregularidad:{
          numericPlus,
        },
        factorArea:{
          numericPlus,
        },
        factorTopografico:{
          numericPlus,
        },
        factorUbicacion:{
          numericPlus,
        },
        factorRestriccion:{
          numericPlus,
        },
        frente:{
          numericPlus,
          between: between(0, 999999)
        },
        fondo:{
          numericPlus,
          between: between(0, 999999)
        },
        desnivel:{
          decimal,
          between: between(-9999, 999999)
        },
        regimenPropiedad:{
          required
        },
        pjeCondominio:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral && this.baseFiscal.regimenPropiedad !=null && this.baseFiscal.regimenPropiedad.toLowerCase().includes('condominio')}),
          numericPlus,
          between: between(0, 100)
        },
        totalAreaComun:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral && this.baseFiscal.regimenPropiedad !=null && this.baseFiscal.regimenPropiedad.toLowerCase().includes('condominio')}),
          numericPlus,
          between: between(0, 99999999)
        },
        totalSupPredio:{
          required:requiredIf(function(){return this.baseFiscal.gestionCatastral}),
          numericPlus,
          between: between(0, 99999999)
        },
      }
    }
  }
</script>
<style>
.input-form-cat{
  text-align: center;
  font-size: 15px;
  font-weight : bold;
}
.label-form-avaluo{
  font-size: 13px;
  color: rgb(143, 141, 141);
  font-weight : bold;
}
.label-form-avaluo-err{
  font-size: 13px;
  color: rgb(255, 20, 20);
  font-weight : semi-bold;
}
.col-form-avaluo{
  margin-bottom: 10px;
}
.col-form-inner{
  
  border:  1px solid rgb(231, 231, 231);
  box-shadow: 0px 1px 5px 1px #cccaca;
  border-radius: 5px;
  border-bottom: solid 4px rgb(255, 147, 47);  
 
  
}
</style>